import React, { useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import { Labels } from "utils/Labels";
import TextInput from "components/Input/TextInput";
import { onlyNumber } from "utils/rejex";
import DefaultSelectInput from "components/SelectInput/SelectInput";
import { Error } from "JsFunctions/Dashboard/AddAgent";
import { baseURL } from "API/Axios";
import CustomModal from "components/Modal/CustomModal";
import ImageCropper from "components/ImageCropper/ImageCropper";
import { Addresses } from "utils/Addresses";

interface Props {
  editAgentHandler: () => void;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  mobile: string;
  setMobile: React.Dispatch<React.SetStateAction<string>>;
  role: string;
  setRole: React.Dispatch<React.SetStateAction<string>>;
  roleList: any;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  activeList: any;
  error: Error;
  gotData: boolean;
  active: string;
  userPrevImage: string;
  handleSelectImage: (e: any) => void;
  showModalCrop: boolean;
  setShowModalCrop: React.Dispatch<React.SetStateAction<boolean>>;
  imageSelectForCrop: any;
  onCropDone: (imgCroppedArea: any) => void;
  onCropCancel: () => void;
  finalImage: string | null;
  removeImageFunc: () => void;
}

const EditAgentPage: React.FC<Props> = ({
  editAgentHandler,
  name,
  setName,
  mobile,
  setMobile,
  role,
  setRole,
  roleList,
  email,
  setEmail,
  setActive,
  activeList,
  error,
  gotData,
  active,
  userPrevImage,
  handleSelectImage,
  showModalCrop,
  setShowModalCrop,
  imageSelectForCrop,
  onCropDone,
  onCropCancel,
  finalImage,
  removeImageFunc,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const SiteText = SiteTexts();

  return (
    <>
      <div className="add-agent-parent">
        <h4>{SiteText.EDIT_AGENT.EDIT_AGENT}</h4>
        {gotData ? (
          <form onSubmit={editAgentHandler}>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Name}
                className={"general-input"}
                error={error.name}
                value={name}
                required={true}
                name={"inpute-name"}
                onChangeValue={setName}
                autoFocus={true}
                regex={""}
                type={"text"}
                removeLable={false}
                maxlength={100}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Mobile}
                className={"general-input"}
                error={error.mobile}
                value={mobile}
                required={true}
                name={"inpute-mobile"}
                onChangeValue={setMobile}
                autoFocus={false}
                regex={onlyNumber}
                type={"tel"}
                removeLable={false}
                maxlength={11}
              />
            </div>
            <div className="text-input-parent">
              <DefaultSelectInput
                lable={Labels.InputLabels.Role}
                className={"general-input"}
                error={error.role}
                required={true}
                name={"inpute-role"}
                onChangeValue={setRole}
                list={roleList}
                disabled={roleList.length > 0 ? false : true}
                defaultValue={role}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Email}
                className={"general-input"}
                error={error.email}
                value={email}
                required={false}
                name={"inpute-email"}
                onChangeValue={setEmail}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
                maxlength={100}
              />
            </div>
            <div className="text-input-parent">
              <DefaultSelectInput
                lable={Labels.InputLabels.Active}
                className={"general-input"}
                error={error.active}
                required={true}
                name={"inpute-active"}
                onChangeValue={setActive}
                list={activeList}
                defaultValue={active}
              />
            </div>
            <div style={{ position: "relative" }} className="text-input-parent">
              <input
                type="file"
                className="upload-img-btn"
                onChange={(e: any) => handleSelectImage(e)}
              />
              <div className="upload-img-view">
                {Labels.ButtonLabels.SELECT_IMAGE}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                marginBottom: "20px",
                position: "relative",
              }}
            >
              {userPrevImage !== "" ? (
                <>
                  <div
                    onClick={() => removeImageFunc()}
                    className="delete-image-btn"
                    title="Remove Image"
                  >
                    <img src={Addresses.icons.CLOSE_MODAL_X_RED} />
                  </div>
                  <img
                    alt="not found"
                    width={"200px"}
                    src={baseURL + userPrevImage}
                    style={{ border: "solid 1px #C4C4C4", cursor: "pointer" }}
                    onClick={() => setShowModal(true)}
                  />
                </>
              ) : finalImage !== "" && finalImage !== null ? (
                <>
                  <div
                    onClick={() => removeImageFunc()}
                    className="delete-image-btn"
                    title="Remove Image"
                  >
                    <img src={Addresses.icons.CLOSE_MODAL_X_RED} />
                  </div>
                  <img
                    alt="not found"
                    width={"200px"}
                    src={finalImage}
                    style={{ border: "solid 1px #C4C4C4", cursor: "pointer" }}
                    onClick={() => setShowModal(true)}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="submit-search-input-parent">
              <button onSubmit={editAgentHandler}>
                {Labels.ButtonLabels.EDIT_AGENT}
              </button>
            </div>
          </form>
        ) : (
          <></>
        )}
      </div>
      <CustomModal
        showModal={showModalCrop}
        close={() => setShowModalCrop(false)}
        closeAble={true}
        maxWidth={"600px"}
      >
        <div className="modal-crop-image-parent">
          <ImageCropper
            image={imageSelectForCrop}
            onCropDone={onCropDone}
            onCropCancel={onCropCancel}
          />
        </div>
      </CustomModal>
      <CustomModal
        showModal={showModal}
        close={() => setShowModal(false)}
        closeAble={true}
        maxWidth={"600px"}
      >
        <div style={{ width: "100%" }}>
          {userPrevImage !== "" ? (
            <>
              <img
                alt="not found"
                width={"100%"}
                src={baseURL + userPrevImage}
              />
            </>
          ) : finalImage !== "" && finalImage !== null ? (
            <>
              <img alt="not found" width={"100%"} src={finalImage} />
            </>
          ) : (
            <></>
          )}
        </div>
      </CustomModal>
    </>
  );
};

export default EditAgentPage;
